import * as yup from 'yup';

export const umpireDetailsSchema = yup.object({
  umpireLocationAvailability: yup
    .string()
    .trim()
    .required('Umpire location availability is required'),
  experienceYears: yup
    .string()
    .trim()
    .required('Experience is required')
    .matches(/^\d+$/, 'Please enter a valid number of years'),
  feesPerHour: yup
    .string()
    .trim()
    .required('Fees per hour is required')
    .matches(/^\d+(\.\d+)?$/, 'Please enter a valid amount'),
  paymentFrequency: yup
    .string()
    .required('Payment frequency is required')
    .test('not-empty', 'Please select payment frequency', (v) => !!v && v !== ''),
});

export type UmpireDetailsFormValues = yup.InferType<typeof umpireDetailsSchema>;
